/* eslint-disable max-lines */
export const desktopIndiaConfig = {
  menuItems: [
    { href: "/", name: "Home India" },
    { href: "/about", name: "About India" },
  ],

  currency: "INR",
  moreInfoDropDown: [
    {
      iconUrl: "/icons/FNP-franchise.svg",
      text: "Start an FNP Franchise",
      label: "",
      landingUrl: "/info/franchise-programme?promo=franchise_enquiry",
    },
    {
      iconUrl: "/icons/become-a-vendor.svg",
      text: "Become a Vendor",
      label: "",
      landingUrl: "/info/become-a-partner?promo=partner_enquiry",
    },
    {
      iconUrl: "/icons/balloon-birthday-wedding-decor.svg",
      text: "Birthday / Wedding Decor",
      label: "",
      landingUrl: "/services/weddings-n-events?promo=wedding_enquiry",
    },
    { iconUrl: "/icons/media.svg", text: "Media", label: "" },
  ],
  /** @deprecated Use headerAccountDropdown in headerToolbarConstants.js */
  accountDropDown: [],
  /** @deprecated Use headerAccountDropdown in headerToolbarConstants.js */
  loggedInAccountDropDown: [],
  footerInfo: [
    {
      id: "worldwide-delivery",
      heading: "Worldwide Delivery",
      subheading: "We deliver gifts to over 70 countries",
    },
    {
      id: "safe-and-secure-payments",
      heading: "100% Safe & Secure Payments",
      subheading: "Pay using secure payment methods",
    },
    {
      id: "dedicated-help-center",
      heading: "Dedicated Help Center",
      subheading1: "Call us +91 9212422000 | 8:00AM-10:30PM",
      subheading2: "Chat With Us",
    },
  ],
  socialIcons: [
    {
      href: "https://www.facebook.com/fnpind",
      id: "facebook",
      ariaLabel: "Visit our facebook page",
    },
    { href: "https://twitter.com/fnp_ind", id: "twitter", ariaLabel: "Visit our twitter page" },
    {
      href: "https://www.instagram.com/fernsnpetalsindia/?hl=en",
      id: "instagram",
      ariaLabel: "Visit our instagram page",
    },
    { href: "https://www.linkedin.com/company/fnp-world", id: "linkedin", ariaLabel: "Visit our linkedin page" },
  ],

  footerBodyLinks: [
    {
      title: "Policy Info",
      links: [
        { path: "/info/terms-and-conditions", linkName: "Terms & Conditions" },
        { path: "/info/privacy-policy", linkName: "Privacy Policy" },
        { path: "/info/terms-of-use", linkName: "Terms of Use" },
        { path: "/info/disclaimer", linkName: "Disclaimer" },
      ],
    },
    {
      title: "About Company",
      links: [
        { path: "/info/about-us", linkName: "About Us" },
        { path: "/info/fnp-team", linkName: "FNP Team" },
        { path: "/info/careers", linkName: "Careers" },
        { path: "/info/testimonials", linkName: "Testimonials" },
        { path: "/info/news", linkName: "News Room" },
        { path: "/blog/", linkName: "Blog" },
      ],
    },
    {
      title: "FNP business",
      links: [
        { path: "/decoration-services-lp", linkName: "Decoration Services" },
        { path: "/corporate/", linkName: "Corporate Service" },
        { path: "/info/affiliate-program", linkName: "Affiliate Program" },
        { path: "/info/retail-stores", linkName: "Retails Stores" },
        { path: "/info/franchise-programme", linkName: "Franchise" },
      ],
    },
    {
      title: "Need Help ?",
      links: [
        { path: "/info/contact-us", linkName: "Contact Us" },
        { path: "/info/faq", linkName: "FAQs" },
      ],
    },
    {
      title: "International Presence",
      links: [
        { path: "https://www.fnp.ae/", linkName: "Dubai" },
        { path: "https://www.fnp.qa/", linkName: "Qatar" },
        { path: "https://www.fnp.sa/", linkName: "Saudi Arabia" },
        { path: "https://www.fnp.sg/", linkName: "Singapore" },
      ],
    },
  ],
  paymentGatewayItems: [
    { id: "visa" },
    { id: "mastercard" },
    { id: "rupay" },
    { id: "diners-club" },
    { id: "american-express" },
  ],
  startYear: "1994",
  isSmartLockEnabled: true,
  isCdpEnabled: true,
  popularMobileCodes: [
    "+91 IND",
    "+1 USA",
    "+1-284 VGB",
    "+61 AUS",
    "+65 SGP",
    "+974 QAT",
    "+64 NZL",
    "+60 MYS",
    "+1 CAN",
    "+971 ARE",
  ],

  animationTime: 300,
  defaultCountry: {
    countryName: "India",
    countryCategoryID: "gifts",
    catelogID: "india",
    countryId: "IND",
    logo: "https://m-i1.fnp.com/assets/images/custom/country-flags/India.png",
    webLogo: "https://m-i1.fnp.com/assets/images/custom/country-flags/india.svg",
    countryCode: "91",
    countryCurrency: "INR",
  },
};

export const fnpBrandsData = {
  csr: {
    content: [
      "Company Name: FNP E Retail Private Limited | CIN: U52100HR2021PTC118882 | Regd. Office: Plot No. 75P, Sector-44, Gurugram, Haryana - 122003",
      "Telephone No.: +91-11-26802680 | Grievance Resolution Officer Name: Mr. Dinesh Tiwari | Contact No.: +91 9212422000 / 9755-248-248 | Email ID - grievance@fnp.com",
    ],
    linkText: "Corporate Social Responsibility (CSR) Policy",
    link: "/info/csr-policy",
  },
};

// Marketing/analytics origins used for preconnect + dns-prefetch in the root layout.
export const dnsPrefetchDomains = [
  "//sslwidget.criteo.com",
  "//gum.criteo.com",
  "//asia.creativecdn.com",
  "//www.google.com",
  "//googleads.g.doubleclick.net",
];
